<template>
    <div class="left-card-container">
        <div v-if=" showObjectsTable" class="right-side-title-actions">
            <span class="left-title">{{ $tc('Object', 2) }}</span>
            <div class="actions-container">
                <div class="search-container">
                    <div class="action-buttons mr-4">
                        <custom-button
                            :label="$t('DeleteAll')"
                            :button-color="'var(--app-primary-base)'"
                            :label-color="'#FFF'"
                            :disabled="false"
                            @buttonClick="handleDeleteAllDialog"
                        />
                    </div>
                    <v-icon> search </v-icon>
                    <InputField
                        inputType="text"
                        :value="search"
                        :placeholder="$t('Search')"
                        :inputStyle="{
                            borderRadius: '0px',
                            width: '130px',
                            borderTop: 'none',
                            borderRight: 'none',
                            borderLeft: 'none',
                            borderBottom: '1px solid rgba(118, 118, 118, 0.50)',
                        }"
                        @input="handleSearch($event)"
                    />
                </div>
            </div>
        </div>
        <div class="table-div-container" :class="{ 'table-div-container': showObjectsTable, 'table-div-container-empty': !showObjectsTable }">
            <div class="empty-table" v-if="!showObjectsTable">
                <p>{{ $t('DeleteLayersMessage') }}</p>
            </div>
            <Table
                v-show="showObjectsTable"
                :checkbox="true"
                tdWidth="t-small"
                :loading="loading"
                :headers="headers"
                :items="layerObjects"
                :sortable="true"
                :emitRowClickBusEvent="false"
                :scroll-id=tableId
                @onScrollBottom="onScrollBottom"
                @onScrollTop="onScrollTop"
                @sortClick="onSortClick"
                @selectedRows="onCheckboxClick($event)"
                ref="objectsTable"
            />
        </div>
        <div v-if="showObjectsTable" class="action-buttons">
            <custom-button
                :label="$t('Cancel')"
                type="cancel"
                :button-color="'#fff'"
                :label-color="'var(--app-primary-base)'"
                :button-styling="actionButtonsStylingSave"
                @buttonClick="handleCancel"
            />
            <custom-button
                :label="$t('Confirm')"
                :button-color="'var(--app-primary-base)'"
                :label-color="'#FFF'"
                :disabled="selectedRows.length===0"
                @buttonClick="deleteDialogIsOpen=true"
            />
        </div>
        <dialog-choice
            :isOpen="deleteDialogIsOpen"
            :title="$t('DeleteObjects')"
            :content="$t('DeleteObjectsMessage')"
            :mainActionLabel="$t('Confirm')"
            @mainAction="handleDeleteDialog"
            :secondaryActionLabel="$t('Cancel')"
            @secondaryAction="handleCancelDeleteDialog"
            icon="mdi-delete"
            iconColor="var(--app-primary-base)"
        />
        <dialog-choice
            :isOpen="confirmationDialogIsOpen"
            :title="$t('DeleteObjectsPermanently')"
            :content="$t('DeleteObjectsPermanentlyMessage')"
            :mainActionLabel="$t('Confirm')"
            @mainAction="handleDeletes"
            :secondaryActionLabel="$t('Cancel')"
            @secondaryAction="handleCancelDeleteConfirmation"
            icon="mdi-delete"
            iconColor="#FF0000"
            :isDeleteDialog="true"
            :loading="deleteLoading"
        />

        <dialog-choice
            title=""
            :isOpen="workspaceDialogIsOpen"
            :content="$t('ChangeGeomConfirmation')"
            :mainActionLabel="$t('Confirm')"
            @mainAction="handleGeomChange"
            :secondaryActionLabel="$t('Cancel')"
            @secondaryAction="workspaceDialogIsOpen=false"
            icon="mdi-delete"
            iconColor="var(--app-primary-base)"
        />

        <dialog-choice
            title=""
            :isOpen="clearAllDialogIsOpen"
            :content="$t('ClearAllConfirmation')"
            :mainActionLabel="$t('Confirm')"
            @mainAction="handleClearAll"
            :secondaryActionLabel="$t('Cancel')"
            @secondaryAction="clearAllDialogIsOpen=false"
            icon="mdi-delete"
            iconColor="var(--app-primary-base)"
        />
    </div>
</template>

<script>
    import { mapActions } from "vuex";
    import { bus } from "@/main.js";
    import Table from "@/newComponents/_Molecules/Table.vue";
    import InputField from "@/newComponents/_Atoms/InputField.vue";
    import DialogContent from "@/newComponents/_Molecules/DialogContent.vue";
    import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
    import CustomButton from '@/newComponents/_Atoms/CustomButton';
    import DialogChoice from '@/newComponents/_Molecules/DialogChoice.vue';

    export default {
        name: "TableViewLayerObjects",

        mixins: [managementDatatableMixin],

        components: {
            Table,
            InputField,
            DialogContent,
            CustomButton,
            DialogChoice
        },

        props: {
            layer:{
                type: String
            },
            workspaceUuid:{
                type: String
            },
            workspaceGeoJson: {
                type: String
            },
            shapeGeom:{
                type: String
            }
        },
        watch: {
            workspaceGeoJson(newValue){
                if(!this.shapeGeom){
                    this.clearTable();
                    this.showObjectsTable = false;
                    bus.$emit("draw-workspace", newValue);
                }else if(this.shapeGeom && newValue){
                    this.workspaceDialogIsOpen = true;
                }
            },
            layerObjects(newValue){
                if(newValue.length > 0){
                    let itemsCoordinates = [];
                    newValue.forEach(item => {
                        itemsCoordinates.push({
                            id: item.id,
                            geo_json:item.geo_json
                        });
                    })
                    bus.$emit('draw-features-highlight', itemsCoordinates)
                }else if(newValue.length === 0){
                    bus.$emit('draw-features-highlight', []);
                }
            },
            selectedRows: {
                handler(newValue) {
                    let itemsIds = [];
                    newValue.forEach(item => {
                        itemsIds.push(item.id);
                    });
                    bus.$emit("highlight-features", itemsIds);
                },
                deep: true
            },
            shapeGeom(newValue) {
                if(newValue){
                    this.$emit('clear-selected-workspace');
                    if(this.layerObjects.length > 0){
                        this.clearTable();
                        this.showObjectsTable = false;
                    }
                }
            }

        },

        data() {
            return {
                fileWasUploaded: false,
                tableId: '1',
                isDeleteAll: false,
                deleteDialogIsOpen: false,
                workspaceDialogIsOpen: false,
                clearAllDialogIsOpen: false,
                confirmationDialogIsOpen: false,
                search: null,
                loading: false,
                deleteLoading:false,
                scrollTop: 0,
                sortOrder: null,
                scrollHeight: 0,
                selectedRows: [],
                pageNumber: 1,
                pagination: 15,
                currentPageTop: 1,
                currentPageBot: 1,
                lastPage: 2,
                layerObjects: [],
                actionButtonsStylingSave: {
                    'box-sizing': 'border-box',
                    'border': '1px solid var(--app-primary-base)',
                    'padding': '5px 19px'
                },
                showObjectsTable: false
            };
        },

        computed: {
            headers() {
                return [
                    { text: this.$i18n.tc("Type", 1), varName: "type", sortable: false},
                    { text: "ID", varName: "id" },
                    { text: "UUID", varName: "uuid" },
                    { text: this.$i18n.tc("Label", 1), varName: "label" },
                ]
            },

        },

        methods: {
            ...mapActions(["DELETE_MATERIAL_ITEMS", "fetchWorkspacesLayersObject", "deleteWorkspacesLayersObject"]),

            openClearAllDialog(){
                this.clearAllDialogIsOpen = true;
            },

            handleClearAll(){
                bus.$emit('zoom-out-map');
                bus.$emit("clear-vector-source-layer");
                this.clearTable();
                this.$emit('clear-selected-workspace');
                this.$emit('clear-shape-geom');
                this.clearAllDialogIsOpen = false;
            },

            handleGeomChange(){
                if(this.layerObjects.length > 0){
                    this.clearTable();
                    this.showObjectsTable = false;
                }
                this.$emit('clear-shape-geom');
                this.workspaceDialogIsOpen = false;
                //draw geom of workspace on map
                bus.$emit("draw-workspace", this.workspaceGeoJson);

            },

            handleDeleteAllDialog(){
                this.deleteDialogIsOpen = true;
                this.isDeleteAll = true;
            },

            handleDeleteDialog(){
                this.deleteDialogIsOpen = false;
                this.confirmationDialogIsOpen = true;
            },

            handleCancelDeleteDialog(){
                this.deleteDialogIsOpen = false;
                if(this.isDeleteAll){
                    this.isDeleteAll = false;
                }
            },

            handleCancelDeleteConfirmation(){
                this.confirmationDialogIsOpen = false;
                if(this.isDeleteAll){
                    this.isDeleteAll = false;
                }
            },

            handleDeletes(){
                //if selected layer is different from layer of objects in table, show warning to user
                if(this.layer !== this.layerObjects[0].layer){
                    this.$toasted.global.toast_error(this.$i18n.t('DeleteObjectsLayerValidation'));
                    return;
                }
                //clear shapeGm  confirm to delete so delete workspace dialog wont appear
                if(this.isDeleteAll){
                    this.handleDeleteAll();
                    return;
                }
                this.handleDeleteConfirmation();

            },

            async handleDeleteConfirmation(){
                try{
                    this.deleteLoading = true;
                    const objectUuids = this.selectedRows.map( row => {
                        return row.uuid
                    });
                    await this.deleteWorkspacesLayersObject({
                        layer: this.layer,
                        data: {
                            uuids: objectUuids
                        }
                    });
                    // Filter out the objects from layerObjects based on the uuids in objectUuids
                    this.layerObjects = [...this.layerObjects.filter(object => !objectUuids.includes(object.uuid))];
                }catch(error){
                    this.$toasted.global.toast_error(error);
                }finally{
                    this.handleClearAll();
                    //clear selected ids
                    bus.$emit("clear-selected-ids");
                    bus.$emit('zoom-out-map');
                    // Reset selectedRows and close the dialog
                    this.$refs.objectsTable.clearSelected();
                    this.$refs.objectsTable.clearSelectedAll();
                    this.selectedRows = [];
                    this.confirmationDialogIsOpen = false;
                    this.deleteLoading = false;
                    this.showObjectsTable = false;
                }
            },

            async handleDeleteAll(){
                try{
                    this.deleteLoading = true;
                    let data = {
                        workspace_uuid: this.workspaceUuid,
                        uuids: [],
                        delete_all: true
                    }

                    if(this.shapeGeom){
                        data = {
                            geom: this.shapeGeom,
                            uuids: [],
                            delete_all: true
                        }
                    }
                    await this.deleteWorkspacesLayersObject({
                        layer: this.layer,
                        data
                    });
                }catch(error){
                    this.$toasted.global.toast_error(error);
                }finally{
                    bus.$emit('zoom-out-map');
                    this.confirmationDialogIsOpen = false;
                    this.isDeleteAll = false;
                    this.showObjectsTable = false;
                    this.clearTable();
                    this.deleteLoading = false;
                }
            },

            handleCancel(){
                this.showObjectsTable = false;
                bus.$emit('zoom-out-map');
                this.clearTable();
            },

            clearTable(){
                this.$refs.objectsTable.clearSelected();
                this.$refs.objectsTable.clearSelectedAll();
                bus.$emit('zoom-out-map');
                this.layerObjects = [];
                this.selectedRows = [];
                this.search = null;
                this.scrollTop = 0;
                this.sortOrder = null;
                this.scrollHeight = 0;
                this.pageNumber = 1;
                this.pagination = 25;
                this.currentPageTop = 1;
                this.currentPageBot = 1;
                this.lastPage = 2;
            },

            getLayers(){
                //reset search and sort
                this.search = null;
                this.sortOrder = null;
                this.$refs.objectsTable.clearSelected();
                this.$refs.objectsTable.clearSelectedAll();
                //clear selected ids
                bus.$emit("clear-selected-ids");
                this.getInitialLayers();
            },

            getInitialLayers() {
                this.currentPageBot = 1
                this.currentPageTop = 1
                let queryParams = {
                    "page[number]": 1,
                    paginate: 25
                };

                if (this.search !== null) {
                    queryParams["filter[search]"] = this.search;
                }

                if (this.sortOrder !== null) {
                    queryParams["sort"] = this.sortOrder;
                }
                this.getAllLayerObjects(queryParams);
            },

            async getAllLayerObjects(queryParams, scrollDirection = null) {
                try {
                    this.loading = true;
                    let body = {
                        queryParams,
                        layer: this.layer,
                        workspaceUuid: this.workspaceUuid
                    }

                    if(this.shapeGeom){
                        body = {
                            queryParams,
                            layer: this.layer,
                            workspaceUuid: null,
                            geom: this.shapeGeom
                        }
                    }

                    const layersObjects = await this.fetchWorkspacesLayersObject(body);
                    // Add type property to each object
                    const processedLayersObjects = layersObjects.data.map(object => {
                        return {
                            ...object,
                            type: this.$i18n.tc(this.$store.getters.getLayerTranslationKey(this.layer), 2)
                        };
                    });
                    if(!this.showObjectsTable){
                        this.showObjectsTable = true;
                    }
                    layersObjects.data = processedLayersObjects;
                    this.processLayerObjectsData(layersObjects, scrollDirection);
                } catch (error) {
                    if(error.response.status === 404){
                        this.$toasted.global.toast_error(error.response.data.message);
                    }else{
                        this.$toasted.global.toast_error(error);
                    }
                }finally {
                    this.loading = false;
                    this.$nextTick(() => this.updateLocalPagination(this.paginationFromParent));
                }
            },

            processLayerObjectsData(layerObjectsData, scrollDirection = null) {
                let allLayerObjects = null;
                let currentScroll = null;
                let rowElement = null;
                switch (scrollDirection) {
                    case 'top':
                        this.lastPage = layerObjectsData.meta.last_page;
                        allLayerObjects = [...layerObjectsData.data, ...this.layerObjects];
                        this.layerObjects = Array.from(new Set(allLayerObjects.map(a => a.id)))
                            .map(id => { return allLayerObjects.find(a => a.id === id) })
                        if (this.layerObjects.length > 75) {
                            this.layerObjects.splice(-(this.layerObjects.length - 75));
                            this.currentPageBot--;
                        }

                        currentScroll = document.getElementById(this.tableId).scrollTop;
                        rowElement = document.getElementById("rowId");
                        if (rowElement) {
                            const rowHeight = rowElement.clientHeight;
                            for (let i = 0; i < 25; i++) {
                            const offset = rowHeight * i;
                            document.getElementById(this.tableId).scrollTo({
                                top: currentScroll + offset,
                                behavior: "smooth",
                            });
                            }
                        }
                    break;
                    case 'bottom':
                        this.lastPage = layerObjectsData.meta.last_page;
                        allLayerObjects = [...this.layerObjects, ...layerObjectsData.data];
                        this.layerObjects = Array.from(new Set(allLayerObjects.map(a => a.id)))
                            .map(id => { return allLayerObjects.find(a => a.id === id) })
                        if (this.layerObjects.length > 75) {
                            this.layerObjects = this.layerObjects.slice(this.layerObjects.length - 75);
                        }

                        currentScroll = document.getElementById(this.tableId).scrollTop;
                        rowElement = document.getElementById("rowId");
                        if (rowElement) {
                            const rowHeight = rowElement.clientHeight;
                            for (let i = 0; i < 2; i++) {
                            const offset = rowHeight * i;
                            document.getElementById(this.tableId).scrollTo({
                                top: currentScroll - offset,
                                behavior: "smooth",
                            });
                            }
                        }
                    break;
                    default:
                        this.layerObjects = layerObjectsData.data;
                        this.lastPage = layerObjectsData.meta.last_page;
                    break;
                }
            },

            getLayerObjectsBottom() {
                this.pagination = 25;
                if (this.layerObjects.length >= 75) {
                    this.currentPageTop++;
                }
                this.currentPageBot++;

                let queryParams = {
                    "page[number]": this.currentPageBot,
                    paginate: this.pagination,
                };

                if (this.search !== null) {
                    queryParams["filter[search]"] = this.search;
                }

                if (this.sortOrder !== null) {
                    queryParams["sort"] = this.sortOrder;
                }

                this.getAllLayerObjects(queryParams, 'bottom');
            },

            async getLayerObjectsTop() {
                this.pagination = 25;
                this.currentPageTop--;

                let queryParams = {
                    "page[number]": this.currentPageTop,
                    paginate: this.pagination,
                };

                if (this.search !== null) {
                    queryParams["filter[search]"] = this.search;
                }

                if (this.sortOrder !== null) {
                    queryParams["sort"] = this.sortOrder;
                }

                this.getAllLayerObjects(queryParams, 'top');
            },

            onCheckboxClick(event) {
                if(event.length === 0){
                    this.selectedRows = [];
                    return;
                }
                this.selectedRows = event.map(row => ({...row}));
            },

            handleSearch: _.debounce(function (event) {
                if (event === "") {
                    this.search = null;
                } else {
                    this.search = event;
                }
                this.layerObjects = [];
                this.getInitialLayers();

            }, 1000),

            onScrollBottom() {
                if (this.currentPageBot !== this.lastPage) {
                    this.pageNumber++;
                    this.getLayerObjectsBottom();
                }
            },

            onScrollTop() {
                if (this.currentPageTop !== 1) {
                    this.pageNumber--;
                    this.getLayerObjectsTop();
                }
            },

            onSortClick(sortOrder, index) {
                if(this.headers[index].varName !== 'type'){
                    const prefix = this.$store.getters.getLayerInitials(this.layer);
                    if (sortOrder === "asc") {
                        this.sortOrder = prefix + '_' + this.headers[index].varName;
                    } else if (sortOrder === "desc") {
                        this.sortOrder = `-${prefix}_${this.headers[index].varName}`;
                    } else {
                        this.sortOrder = sortOrder;
                    }
                    this.getInitialLayers();
                }
            },
        },
    };
</script>

<style scoped>
    .search-container {
        display: flex;
        align-items: center;
    }

    .table-div-container {
        height: calc(100% - 72px);
        margin-top: 5px;
        margin-bottom: 2px;
    }

    .table-div-container-empty{
        height: 100%;
        margin-top: 5px;
        color: var(--app-primary-base);
        font-size: 12px;
        font-weight: 600;
        line-height: normal;
    }

    .actions-container {
        display: flex;
        align-items: center;
        gap: 3px;
    }

    .left-title {
        color: #767676;
        font-family: Lato;
        font-size: 10px;
        font-style: normal;
        font-weight: 800;
        line-height: 20px;
        text-transform: uppercase;
    }

    .right-side-title-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 34px;
    }

    .left-card-container {
        width: 100%;
        height: 100%;
        border-radius: 8px;
        background: #fff;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
        padding: 19px 19px;
    }

    .action-buttons {
        display: flex;
        flex-direction: row;
        gap: 10px;
        justify-content: flex-end;
        align-items: center;
    }
    .empty-table{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>



// WEBPACK FOOTER //
// src/newComponents/Data/Delete/TableViewLayerObjects.vue